import { ScreenSpaceEventType } from "cesium";
import { DtmCesiumLongPressEvents } from "./cesium-events.model";

export class DtmCesiumDragDropHelper {
    public static dragEvents: Set<DtmCesiumLongPressEvents> = new Set([
        DtmCesiumLongPressEvents.LEFT_CLICK_DRAG,
        DtmCesiumLongPressEvents.RIGHT_CLICK_DRAG,
        DtmCesiumLongPressEvents.MIDDLE_CLICK_DRAG,
    ]);

    public static getDragEventTypes(dragEvent: DtmCesiumLongPressEvents) {
        let mouseDownEvent;
        let mouseUpEvent;
        if (dragEvent === DtmCesiumLongPressEvents.LEFT_CLICK_DRAG) {
            mouseDownEvent = ScreenSpaceEventType.LEFT_DOWN;
            mouseUpEvent = ScreenSpaceEventType.LEFT_UP;
        } else if (dragEvent === DtmCesiumLongPressEvents.RIGHT_CLICK_DRAG) {
            mouseDownEvent = ScreenSpaceEventType.RIGHT_DOWN;
            mouseUpEvent = ScreenSpaceEventType.RIGHT_UP;
        } else if (dragEvent === DtmCesiumLongPressEvents.MIDDLE_CLICK_DRAG) {
            mouseDownEvent = ScreenSpaceEventType.MIDDLE_DOWN;
            mouseUpEvent = ScreenSpaceEventType.MIDDLE_UP;
        }

        if (mouseDownEvent === undefined || mouseUpEvent === undefined) {
            throw new Error("Unsupported drag event type");
        }

        return { mouseDownEvent, mouseUpEvent };
    }
}
